import type { TAnalyticArgs, TAnalytics } from '@/common/types/analytics.type';

// Dynamically import third-party dependencies to avoid Edge Runtime issues
const sendGTMEvent = async (data: Record<string, any>) => {
  if (typeof window !== 'undefined') {
    const { sendGTMEvent: gtmSender } =
      await import('@next/third-parties/google');
    gtmSender(data);
  }
};

const logEvent = async <K extends keyof TAnalytics>(
  event: K,
  ...params: TAnalytics[K] extends undefined | null
    ? [undefined?]
    : [TAnalytics[K]]
) => {
  // Only run analytics on client-side
  if (typeof window === 'undefined') return;

  await sendGTMEvent({
    event,
    ...(params?.[0] ? params[0] : {}),
  });
};

export const logEventAsArray = (analytics: TAnalyticArgs) => {
  if (!Array.isArray(analytics)) {
    return;
  }

  const [event, params] = analytics;
  logEvent(event as keyof TAnalytics, params ?? null);
};
